'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _reduxActions = require('redux-actions');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _RequestStatus = require('conversations-core/data/records/RequestStatus');

var _RequestStatus2 = _interopRequireDefault(_RequestStatus);

var _RequestStatusTypes = require('conversations-schema/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

var _strings = require('conversations-core/constants/strings');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = new _RequestStatus2.default();

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes2.default.SET_CURRENT_CHANNEL, function (state, action) {
  var channel = action.payload.channel;

  var widgetStatus = state.getIn(['chatHistoryFetchStatus', _strings.INITIAL_ONLINE_MODE_CHANNEL]);

  if (!widgetStatus) return state;

  return state.setIn(['chatHistoryFetchStatus', channel], widgetStatus);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_MESSAGES, function (state) {
  return state.set('messagesFetchStatus', _RequestStatusTypes2.default.PENDING);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_MESSAGES_FAILED, function (state) {
  return state.set('messagesFetchStatus', _RequestStatusTypes2.default.FAILED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_MESSAGES_SUCCEEDED, function (state) {
  return state.set('messagesFetchStatus', _RequestStatusTypes2.default.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_CONVERSATIONS, function (state) {
  return state.set('conversationsFetchStatus', _RequestStatusTypes2.default.PENDING);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_CONVERSATIONS_FAILED, function (state) {
  return state.set('conversationsFetchStatus', _RequestStatusTypes2.default.FAILED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_CONVERSATIONS_SUCCEEDED, function (state) {
  return state.set('conversationsFetchStatus', _RequestStatusTypes2.default.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_CHAT_HISTORY, function (state, action) {
  var channel = action.payload.channel;

  return state.setIn(['chatHistoryFetchStatus', channel], _RequestStatusTypes2.default.PENDING);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_CHAT_HISTORY_FAILED, function (state, action) {
  var channel = action.payload.channel;

  return state.setIn(['chatHistoryFetchStatus', channel], _RequestStatusTypes2.default.FAILED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_CHAT_HISTORY_SUCCEEDED, function (state, action) {
  var channel = action.payload.channel;

  return state.setIn(['chatHistoryFetchStatus', channel], _RequestStatusTypes2.default.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes2.default.UPDATE_MESSAGE, function (state) {
  return state.set('messageUpdateStatus', _RequestStatusTypes2.default.PENDING);
}), _defineProperty(_handleActions, _ActionTypes2.default.UPDATE_MESSAGE_FAILED, function (state) {
  return state.set('messageUpdateStatus', _RequestStatusTypes2.default.FAILED);
}), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(_ActionTypes2.default.UPDATE_MESSAGE_SUCCEEDED, _ActionTypes2.default.TOGGLE_MESSAGE_STATUS), function (state) {
  return state.set('messageUpdateStatus', _RequestStatusTypes2.default.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_USER_SETTINGS, function (state) {
  return state.set('userSettingsFetchStatus', _RequestStatusTypes2.default.PENDING);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_USER_SETTINGS_SUCCEEDED, function (state) {
  return state.set('userSettingsFetchStatus', _RequestStatusTypes2.default.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_USER_SETTINGS_FAILED, function (state) {
  return state.set('userSettingsFetchStatus', _RequestStatusTypes2.default.FAILED);
}), _defineProperty(_handleActions, _ActionTypes2.default.UPDATE_USER_SETTINGS, function (state) {
  return state.set('userSettingsUpdateStatus', _RequestStatusTypes2.default.PENDING);
}), _defineProperty(_handleActions, _ActionTypes2.default.UPDATE_USER_SETTINGS_SUCCEEDED, function (state) {
  return state.set('userSettingsUpdateStatus', _RequestStatusTypes2.default.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes2.default.UPDATE_USER_SETTINGS_FAILED, function (state) {
  return state.set('userSettingsUpdateStatus', _RequestStatusTypes2.default.FAILED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_PORTAL_SETTINGS, function (state) {
  return state.set('portalSettingsFetchStatus', _RequestStatusTypes2.default.PENDING);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_PORTAL_SETTINGS_SUCCEEDED, function (state) {
  return state.set('portalSettingsFetchStatus', _RequestStatusTypes2.default.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_PORTAL_SETTINGS_FAILED, function (state) {
  return state.set('portalSettingsFetchStatus', _RequestStatusTypes2.default.FAILED);
}), _defineProperty(_handleActions, _ActionTypes2.default.UPDATE_PORTAL_SETTINGS, function (state) {
  return state.set('portalSettingsUpdateStatus', _RequestStatusTypes2.default.PENDING);
}), _defineProperty(_handleActions, _ActionTypes2.default.UPDATE_PORTAL_SETTINGS_SUCCEEDED, function (state) {
  return state.set('portalSettingsUpdateStatus', _RequestStatusTypes2.default.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes2.default.UPDATE_PORTAL_SETTINGS_FAILED, function (state) {
  return state.set('portalSettingsUpdateStatus', _RequestStatusTypes2.default.FAILED);
}), _defineProperty(_handleActions, _ActionTypes2.default.SEND_VISITOR_EMAIL_ADDRESS, function (state) {
  return state.set('sendVisitorEmailAddressStatus', _RequestStatusTypes2.default.PENDING);
}), _defineProperty(_handleActions, _ActionTypes2.default.SEND_VISITOR_EMAIL_ADDRESS_SUCCEEDED, function (state) {
  return state.set('sendVisitorEmailAddressStatus', _RequestStatusTypes2.default.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes2.default.SEND_VISITOR_EMAIL_ADDRESS_FAILED, function (state) {
  return state.set('sendVisitorEmailAddressStatus', _RequestStatusTypes2.default.FAILED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_CONTACT_SUCCEEDED, function (state) {
  return state.set('fetchContactStatus', _RequestStatusTypes2.default.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_CONTACT_FAILED, function (state) {
  return state.set('fetchContactStatus', _RequestStatusTypes2.default.FAILED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_CONTACT, function (state) {
  return state.set('fetchContactStatus', _RequestStatusTypes2.default.PENDING);
}), _defineProperty(_handleActions, _ActionTypes2.default.CLEAR_CONTACT, function (state) {
  return state.set('fetchContactStatus', _RequestStatusTypes2.default.UNINITIALIZED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_USERS, function (state) {
  return state.set('usersFetchStatus', _RequestStatusTypes2.default.PENDING);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_USERS_SUCCEEDED, function (state) {
  return state.set('usersFetchStatus', _RequestStatusTypes2.default.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_USERS_FAILED, function (state) {
  return state.set('usersFetchStatus', _RequestStatusTypes2.default.FAILED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_TEAMS, function (state) {
  return state.set('teamsFetchStatus', _RequestStatusTypes2.default.PENDING);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_TEAMS_SUCCEEDED, function (state) {
  return state.set('teamsFetchStatus', _RequestStatusTypes2.default.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_TEAMS_FAILED, function (state) {
  return state.set('teamsFetchStatus', _RequestStatusTypes2.default.FAILED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_MEETINGS_LINKS, function (state) {
  return state.set('meetingsLinksFetchStatus', _RequestStatusTypes2.default.PENDING);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_MEETINGS_LINKS_SUCCEEDED, function (state) {
  return state.set('meetingsLinksFetchStatus', _RequestStatusTypes2.default.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_MEETINGS_LINKS_FAILED, function (state) {
  return state.set('meetingsLinksFetchStatus', _RequestStatusTypes2.default.FAILED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_SNIPPETS, function (state) {
  return state.set('snippetsFetchStatus', _RequestStatusTypes2.default.PENDING);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_SNIPPETS_SUCCEEDED, function (state) {
  return state.set('snippetsFetchStatus', _RequestStatusTypes2.default.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_SNIPPETS_FAILED, function (state) {
  return state.set('snippetsFetchStatus', _RequestStatusTypes2.default.FAILED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_SMART_LISTS, function (state) {
  return state.set('smartListsFetchStatus', _RequestStatusTypes2.default.PENDING);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_SMART_LISTS_SUCCEEDED, function (state) {
  return state.set('smartListsFetchStatus', _RequestStatusTypes2.default.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_SMART_LISTS_FAILED, function (state) {
  return state.set('smartListsFetchStatus', _RequestStatusTypes2.default.FAILED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_WIDGET_DATA, function (state) {
  return state.set('widgetData', _RequestStatusTypes2.default.PENDING);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_WIDGET_DATA_SUCCEEDED, function (state) {
  return state.set('widgetData', _RequestStatusTypes2.default.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_WIDGET_DATA_FAILED, function (state) {
  return state.set('widgetData', _RequestStatusTypes2.default.FAILED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_SERVER_TIME_OFFSET, function (state) {
  return state.set('serverTimeOffsetStatus', _RequestStatusTypes2.default.PENDING);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_SERVER_TIME_OFFSET_SUCCEEDED, function (state) {
  return state.set('serverTimeOffsetStatus', _RequestStatusTypes2.default.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_SERVER_TIME_OFFSET_FAILED, function (state) {
  return state.set('serverTimeOffsetStatus', _RequestStatusTypes2.default.FAILED);
}), _defineProperty(_handleActions, _ActionTypes2.default.RESET_STATUS, function (state, action) {
  return state.set(action.payload.key, _RequestStatusTypes2.default.UNINITIALIZED);
}), _defineProperty(_handleActions, _ActionTypes2.default.FETCH_BLOCKED_VISITORS, function (state) {
  return state.set('blockVisitorFetchStatus', _RequestStatusTypes2.default.PENDING);
}), _defineProperty(_handleActions, _ActionTypes2.default.FETCH_BLOCKED_VISITORS_SUCCEEDED, function (state) {
  return state.set('blockVisitorFetchStatus', _RequestStatusTypes2.default.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes2.default.FETCH_BLOCKED_VISITORS_FAILED, function (state) {
  return state.set('blockVisitorFetchStatus', _RequestStatusTypes2.default.FAILED);
}), _defineProperty(_handleActions, _ActionTypes2.default.BLOCK_VISITOR, function (state) {
  return state.set('blockVisitorStatus', _RequestStatusTypes2.default.PENDING);
}), _defineProperty(_handleActions, _ActionTypes2.default.BLOCK_VISITOR_REQUEST_SUCCEEDED, function (state) {
  return state.set('blockVisitorStatus', _RequestStatusTypes2.default.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes2.default.BLOCK_VISITOR_REQUEST_FAILED, function (state) {
  return state.set('blockVisitorStatus', _RequestStatusTypes2.default.FAILED);
}), _defineProperty(_handleActions, _ActionTypes2.default.DELETE_BLOCKED_VISITOR, function (state) {
  return state.set('blockedVisitorDeleteStatus', _RequestStatusTypes2.default.PENDING);
}), _defineProperty(_handleActions, _ActionTypes2.default.DELETE_BLOCKED_VISITOR_SUCCEEDED, function (state) {
  return state.set('blockedVisitorDeleteStatus', _RequestStatusTypes2.default.SUCCEEDED);
}), _defineProperty(_handleActions, _ActionTypes2.default.DELETE_BLOCKED_VISITOR_FAILED, function (state) {
  return state.set('blockedVisitorDeleteStatus', _RequestStatusTypes2.default.FAILED);
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/reducers/requestStatus.js
// module id = 514
// module chunks = 0